export { default as ConsentProvider } from "./react/ConsentProvider";
export { useConsent } from "./react/useConsent";
export { defaultConsentState } from "./react/ConsentContext";
export type { ConsentContextValue, ConsentSource } from "./react/ConsentContext";
export { ConsentBanner } from "./banner";
export { CONSENT_STORAGE_KEYS, clearStoredConsent, createConsentStack } from "./consent.stack";
export type { ConsentStack, ConsentStackOptions } from "./consent.stack";
export type { ConsentStatusStore } from "./engine/consent.engine";
// The non-React read/act surface: the live status for code outside React
// (diagnostics, tests), and the same reopen `useConsent` exposes.
export { getActiveConsentStore, reopenConsentBanner } from "./engine/consent.runtime";
export { CONSENT_SCOPES } from "./domain";
export type {
  ConsentChoice,
  ConsentDecision,
  ConsentScope,
  ConsentState,
  ConsentStatus,
  RequirableScope,
} from "./domain";
